export default "__VITE_ASSET__TfNRQo8L__"